import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconEditorLowercase$1 = /*@__PURE__*/ proxyCustomElement(class WppIconEditorLowercase extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-editor-lowercase", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M11.75 3.25C12.1642 3.25 12.5 3.58579 12.5 4V8.65686C12.9926 8.24347 13.5969 8 14.25 8C15.9069 8 17.25 9.567 17.25 11.5C17.25 13.433 15.9069 15 14.25 15C13.5969 15 12.9926 14.7565 12.5 14.3431V14.5C12.5 14.9142 12.1642 15.25 11.75 15.25C11.3358 15.25 11 14.9142 11 14.5V4C11 3.58579 11.3358 3.25 11.75 3.25ZM14.25 13.5C14.8698 13.5 15.75 12.8298 15.75 11.5C15.75 10.1702 14.8698 9.5 14.25 9.5C13.6302 9.5 12.75 10.1702 12.75 11.5C12.75 12.8298 13.6302 13.5 14.25 13.5ZM5.65399 8.93708C5.19554 8.95472 4.80452 9.06151 4.58555 9.171C4.21507 9.35624 3.76456 9.20607 3.57932 8.83559C3.39408 8.4651 3.54425 8.0146 3.91473 7.82936C4.36243 7.60551 4.97141 7.46224 5.59629 7.43819C6.22522 7.41398 6.94242 7.50771 7.58562 7.82939C9.00597 8.53974 9.00173 9.95435 9.00023 10.4566L9.00014 10.5001V14.4999C9.00014 14.9141 8.66435 15.2499 8.25014 15.2499C7.85489 15.2499 7.53105 14.9441 7.50223 14.5562C6.63084 15.0945 5.61112 15.4068 4.55679 15.1253C2.48001 14.5707 1.75572 11.7614 3.83351 10.3764C4.60798 9.8601 5.53617 9.72421 6.35969 9.76592C6.73888 9.78512 7.11324 9.84266 7.46484 9.92806C7.4097 9.61719 7.26947 9.34841 6.91467 9.17096C6.55786 8.99252 6.10839 8.91959 5.65399 8.93708ZM7.50014 11.4994C7.14595 11.3774 6.72105 11.2861 6.28382 11.264C5.65502 11.2322 5.08273 11.3464 4.66549 11.6245C3.74216 12.24 4.02012 13.4294 4.94379 13.6761C5.6948 13.8766 6.612 13.4926 7.50014 12.68V11.4994Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-editor-lowercase-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-editor-lowercase", "wpp-icon-editor-lowercase-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-editor-lowercase-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-editor-lowercase-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconEditorLowercase$1);
      }
      break;
  } });
}

const WppIconEditorLowercase = WppIconEditorLowercase$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconEditorLowercase, defineCustomElement };
